export const expandTree = (node, path = []) => {
  let acc = {};

  if (Array.isArray(node)) {
    if (path.length > 0) {
      acc[path[path.length - 1].toUpperCase()] = path;
    }
    if (node.length === 0) {
      // Acción directa: usar la última clave como permiso
      const action = path[path.length - 1];
      acc[action.toUpperCase()] = [...path];
    } else {
      node.forEach((leaf) => {
        acc[leaf.toUpperCase()] = [...path, leaf];
      });
    }
  } else if (typeof node === "object" && node !== null) {
    // Guardar también el path del nodo actual (intermedio)
    if (path.length > 0) {
      acc[path[path.length - 1].toUpperCase()] = path;
    }

    Object.entries(node).forEach(([key, value]) => {
      Object.assign(acc, expandTree(value, [...path, key]));
    });
  }

  return acc;
};
